import { createReducer, on } from '@ngrx/store';
import * as RoutingActions from './routing.actions';
import { initialRoutingSlice } from '../initial-slices';
import { RoutingSlice } from '../app-state';

export const routingReducer = createReducer(
  initialRoutingSlice,
  on(RoutingActions.setPipelineReleaseViewRouteParameters, (state, props): RoutingSlice => {
    return {
      ...state,
      pipelineReleaseViewRoute: {
        deliveryGuid: props.deliveryGuid,
        pipelineId: props.pipelineId,
        microdeliveryId: props.microdeliveryId,
        pipelineRunId: props.pipelineRunId,
        pipelineRunKey: props.pipelineRunKey,
        expectedCentralPolicyKeys: props.expectedCentralPolicyKeys,
      },
    };
  }),
);
